'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useRef, useState } from 'react';
export const ModalContext = createContext({
    useModalRef: () => ({}),
    useModal: () => ({}),
    showModal: () => { },
    closeModal: () => { },
    setModalReady: () => { },
    useModalReady: () => false,
    updateModal: () => { }
});
export const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState(null);
    const [modalReady, setModalReady] = useState(false);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const useModalRef = () => {
        return ref;
    };
    const useModal = () => {
        return modal;
    };
    const showModal = (data) => {
        setModal({
            ...data,
            open: true
        });
    };
    const updateModal = (data) => {
        setModal({
            ...modal,
            ...data
        });
    };
    const closeModal = () => {
        setModal(null);
    };
    const useModalReady = () => {
        return modalReady;
    };
    return (_jsx(ModalContext.Provider, { value: {
            useModalRef,
            useModal,
            showModal,
            closeModal,
            updateModal,
            setModalReady,
            useModalReady
        }, children: children }));
};
